module.exports = __webpack_public_path__ + "img/bg_bet2.4530c7cf.png";